<template>
  <tr class="patient-row">
    <td class="patient-col" style="width:5%;">
      <profile-preview-image
        :profileId="user.profileId"
        :uuid="user.uuid"
        :avatarSize="48"
        :avatarClasses="['patient__avatar', 'avatar', 'rounded']"
        :imageClasses="['patient-card__avatar']"
        :thumbnailUrl="user.thumbnailUrl"
      />
    </td>
    <td class="patient-col" colspan="2" style="width: 30%">
      <h4 @click="$emit('to-user', user.id)" class="patient__name">
        {{ user.firstName }} {{ user.lastName }}
      </h4>
      <p>
        <span class="pr-2">{{ user.isActive ? 'Active' : 'Inactive' }}</span>
        <span class="bhGray2--text text-nowrap">
          {{ user.creationDate | moment('MMMM Do, YYYY') }}
        </span>
      </p>
    </td>
    <td class="patient-col" style="width:10%;">
      <strong class="accent--text">
        {{ user.practiceUserFullName }}
      </strong>
      <p class="bhGray2--text" v-if="user.practiceUserFullName">
        Advisor
      </p>
    </td>
    <td class="patient-col">
      <strong class="accent--text">{{
        user.lastUpdatedSwaps | moment('MM/DD/YYYY h:mm A')
      }}</strong>
    </td>
    <td class="patient-col">
      <strong class="accent--text">{{
        user.lastActivity | moment('MM/DD/YYYY h:mm A')
      }}</strong>
    </td>
    <td class="patient-col" style="width:15%;">
      <strong class="bhBlack--text text-nowrap">
        {{ phoneUsFormat(user.phone) }}
      </strong>
    </td>
    <td class="patient-col" style="width:35%;">
      <v-tooltip bottom open-delay="200">
        <template v-slot:activator="{ on, attrs }">
          <p class="bhBlack--text wrapped" v-bind="attrs" v-on="on">
            {{ user.notes }}
          </p>
        </template>
        <span>{{ user.notes }}</span>
      </v-tooltip>
    </td>
    <td class="patient-col">
      <v-btn
        icon
        color="accent"
        elevation="0"
        @click="$emit('to-user', user.id)"
      >
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
    </td>
  </tr>
</template>

<script>
import phoneFormat from '@/helpers/phoneFormat.js'
import ProfilePreviewImage from '../profile/ProfilePreviewImage.vue'
export default {
  components: { ProfilePreviewImage },
  name: 'ParticipantsListTableRow',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data: () => ({}),
  methods: {
    phoneUsFormat: phoneFormat.phoneUsFormat,
  },
}
</script>

<style lang="scss">
.patient {
  &__name {
    min-width: 150px;
    max-width: 200px;
    margin-bottom: 4px;
    cursor: pointer;
  }

  &__avatar {
    overflow: hidden;
    border-radius: 8px;
    width: 48px;
    height: 48px;
    .v-image {
      object-fit: cover;
      height: 100%;
      width: 100%;
    }
  }

  &-row {
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.04);
    border-radius: $border-radius-root;

    &:hover {
      background: transparent !important;
    }
  }

  &-col {
    padding: 8px !important;
    border-bottom: 0 !important;
    background: $bh-white;

    strong {
      display: inline-block;
      margin-bottom: 4px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    p {
      font-size: 0.857rem;
      line-height: 1rem;
      &.wrapped {
        overflow: hidden;
        text-overflow: ellipsis;
        width: 300px;
        white-space: nowrap;
        margin-bottom: 0;
        &::after {
          content: '';
          display: block;
        }
      }
    }

    p:last-child {
      margin-bottom: 0;
    }

    &:first-of-type {
      min-width: 0;
      border-top-left-radius: $border-radius-root;
      border-bottom-left-radius: $border-radius-root;
    }

    &:last-of-type {
      min-width: 0;
      border-top-right-radius: $border-radius-root;
      border-bottom-right-radius: $border-radius-root;
    }
    &--full {
      width: 100%;
    }
  }
}
</style>
